<template>
    <b-alert
        :dismissible="dismissible"
        :fade="fade"
        :show="show"
        :variant="color"
        @dismissCountDown="$emit('dismiss-count-down', $event)"
        @dismissed="$emit('dismissed', $event)"
        @input="$emit('input', $event)"
    >
        <slot />
    </b-alert>
</template>

<script>
import { BAlert } from 'bootstrap-vue'

export default {
    components: { BAlert },
    props: {
        color: { type: String, default: 'info' },
        dismissible: { type: Boolean },
        fade: { type: Boolean },
        show: { type: [Boolean, Number, String], default: true },
    },
}
</script>

<style scoped>
.alert {
    margin: 0.25rem 0;
}
</style>